import type { GradesType } from "../../../../../common-deprecated/types/GradesType";
import { type GradesActionType, SET_GRADES } from "../actions/GradesActions";

export type GradesReducerType = {
    initialized: boolean;
    modelId: string;
    modelName: string;
    modelCode: string;
    submodelId?: string;
    submodelName?: string;
    list: GradesType[];
};

export const initialState: GradesReducerType = {
    initialized: false,
    modelId: "",
    modelName: "",
    modelCode: "",
    submodelId: "",
    submodelName: "",
    list: [],
};

const gradesReducer = (state: GradesReducerType = initialState, action: GradesActionType): GradesReducerType => {
    switch (action.type) {
        case SET_GRADES:
            const { modelId, modelName, modelCode, submodelId, submodelName, grades } = action.grades;
            return {
                ...initialState,
                initialized: true,
                modelId,
                modelName,
                modelCode,
                submodelId,
                submodelName,
                list: grades,
            };
        default:
            return state;
    }
};

export default gradesReducer;
